import PropTypes from "prop-types";
import { Image, CTABlock } from "@lululemon/dsp-ecom-pattern-library";
import styles from "./sweat-with-us-experiential-store.module.scss";

const ImgContent = ({ url }) => (
  <Image
    className={styles.image}
    containerClassName={styles.imagePrimary}
    src={url}
    alt=""
  />
);

const SweatWithUsBlock = ({ item, hasOneLinkTranslation }) => {
  const redirectHref = item.href.includes("@lululemon.com")
    ? "mailto:" + item.href
    : item.href;

  return (
    <div className={styles.sweatWithUsExperientialStoreContent}>
      <div className={styles.imgContainer}>
        <ImgContent url={item.imgUrl} />
      </div>
      <div className={styles.textContainer}>
        <h2 className={styles.heading}>{item.title}</h2>
        <p className={styles.description}>{item.blurb}</p>
      </div>
      <div className={styles.ctaContainer} data-testid="ctaContainer">
        <CTABlock
          href={redirectHref}
          heading={<div>{item.ctaHeading}</div>}
          subContent={item.ctaSubContent}
          style={hasOneLinkTranslation && { pointerEvents: `none` }}
        />
      </div>
    </div>
  );
};

const SweatWithUsExperientialStore = ({ content, hasOneLinkTranslation }) => {
  return (
    <>
      {content.map((item) => (
        <SweatWithUsBlock
          key={item.title}
          item={item}
          hasOneLinkTranslation={hasOneLinkTranslation}
        />
      ))}
    </>
  );
};

ImgContent.propTypes = {
  url: PropTypes.string
};

ImgContent.defaultProps = {
  url: ""
};

SweatWithUsBlock.propTypes = {
  item: PropTypes.shape(),
  hasOneLinkTranslation: PropTypes.bool
};

SweatWithUsBlock.defaultProps = {
  item: {},
  hasOneLinkTranslation: false
};

SweatWithUsExperientialStore.propTypes = {
  content: PropTypes.arrayOf(
    PropTypes.shape({
      heading: PropTypes.string,
      description: PropTypes.string,
      featureBlocks: PropTypes.func,
      // eslint-disable-next-line react/forbid-prop-types
      cta: PropTypes.object,
      id: PropTypes.string
    })
  ),
  hasOneLinkTranslation: PropTypes.bool
};

SweatWithUsExperientialStore.defaultProps = {
  content: [],
  hasOneLinkTranslation: false
};

export default SweatWithUsExperientialStore;
